//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminProcessTemplateController_findAll,
  Response$AdminProcessTemplateController_findAll$Status$200,
  ResponseContentType$AdminProcessTemplateController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminProcessTemplateController_findAll = (options: {
  params: Params$AdminProcessTemplateController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminProcessTemplateController_findAll$Status$200[ResponseContentType$AdminProcessTemplateController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminProcessTemplateController_findAll,
    Response$AdminProcessTemplateController_findAll$Status$200[ResponseContentType$AdminProcessTemplateController_findAll]
  >({
    method: 'AdminProcessTemplateController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
